import api from "../../../services/apiClient"
import type { NotificationAssignmentFormValues } from "../models/notificationAssignment"

const BASE = "notification-assignment"

export const notificationAssignmentApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },
  create: async (values: NotificationAssignmentFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },
  delete: async (role: string, notificationKey: string) => {
    const { data } = await api.post(`${BASE}/delete`, {
      role,
      notification_key: notificationKey,
    })
    return data
  },
  getRoles: async () => {
    const { data } = await api.get(`${BASE}/roles`)
    return data?.data ?? data
  },
}
